import { useEffect, useState } from 'react';
import { getMetaConnectionStatus } from '../../services/MetaConnectionService';

/**
 * O setor tem conta ativa da Meta? Decide se a lista de Conversas oferece o filtro "Instagram" e a resposta pelo Instagram.
 * Sem permissão ou com a consulta falhando, fica como "sem conta" (nada aparece).
 */
export function useMetaChannels(sectorId: number | null): {
  instagramActive: boolean;
  messengerActive: boolean;
  /** O setor fala pelo WhatsApp oficial direto na Meta (conta viva, mesmo que precise reconectar): vale a janela de 24 h. */
  whatsAppCloudActive: boolean;
} {
  const none = { instagramActive: false, messengerActive: false, whatsAppCloudActive: false };
  const [state, setState] = useState(none);
  useEffect(() => {
    setState(none);
    if (!sectorId) return;
    let alive = true;
    getMetaConnectionStatus(sectorId)
      .then((s) => {
        if (!alive) return;
        const active = (channel: string) => (s.accounts || []).some((a) => a.channel === channel && a.status === 'active');
        setState({
          instagramActive: active('instagram'),
          messengerActive: active('messenger'),
          // O status só lista contas vivas: qualquer uma do WhatsApp basta (reconectar é erro claro no envio, não outro caminho).
          whatsAppCloudActive: (s.accounts || []).some((a) => a.channel === 'whatsapp'),
        });
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectorId]);
  return state;
}
